import { Record } from 'immutable'
import { Area, IArea } from './Area'

export interface ILot {
  readonly associatedPropertyId: string
  readonly id: string
  readonly lotDescription: string
  readonly lotNo: string
  readonly lotSize: IArea
  readonly maxContiguous: number
  readonly minDivisible: number
  readonly parcelId: string
}

const LotRecord = Record({
  associatedPropertyId: '',
  id: '',
  lotDescription: '',
  lotNo: '',
  lotSize: new Area(),
  maxContiguous: 0,
  minDivisible: 0,
  parcelId: '',
})

export class Lot extends LotRecord implements ILot {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Lot()
    }

    const { lotSize, ...rest } = initialState

    return new Lot({
      lotSize: Area.fromJS(lotSize),
      ...rest,
    })
  }

  public readonly associatedPropertyId: string
  public readonly id: string
  public readonly lotDescription: string
  public readonly lotNo: string
  public readonly lotSize: Area
  public readonly maxContiguous: number
  public readonly minDivisible: number
  public readonly parcelId: string

  constructor(props?: Partial<Lot>) {
    props ? super(props) : super()
  }
}
